export default __webpack_public_path__ + "static/media/m.1956df9e.svg";